module.exports = __webpack_public_path__ + "img/DefaultPlant.e45edf53.png";